import { useState } from "react";

const SubsidiaryDepartmentReadOnlyRow = ({ index, t, subsidiaryDeptItem, handleDeleteClick, oddIdx, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, subsidiaryDeptItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, subsidiaryDeptItem, submitComplete);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryDeptItem.companyName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryDeptItem.departmentName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{subsidiaryDeptItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, subsidiaryDeptItem)}>
					{subsidiaryDeptItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default SubsidiaryDepartmentReadOnlyRow;